// extracted by mini-css-extract-plugin
export default {"header":"index_header__-YDsh","app-logo":"index_app-logo__bgBZe","scrollbar":"index_scrollbar__uhpe2","menuItem":"index_menuItem__oW2e+","downloadIcon":"index_downloadIcon__yAXh2"};